var GetSelectedTab = function () {
  var $selectedTab = $(".apptus-tab.active:last");
  
  return $selectedTab;
}

export default GetSelectedTab;